// TOP LEVEL IMPORTS
import React from 'react';
import PropTypes from 'prop-types';
// MATERIAL UI
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
// STYLE
import ActionPageview from '@mui/icons-material/Pageview';
import { greyBDBDBD } from '../../../styles/miEdgeColors';

const styles = (theme) => ({
  gridItemRightAlign: {
    display: 'flex',
    justifyContent: 'flex-end',
    paddingRight: theme.spacing(0.5),
  },
  gridItemLeftAlign: {
    paddingLeft: theme.spacing(0.5),
  },
  gridItemCenterAlign: {
    display: 'flex',
    justifyContent: 'center',
  },
  iconSmall: {
    color: greyBDBDBD,
    width: '48px',
    height: '48px',
  },
  iconLarge: {
    color: greyBDBDBD,
    paddingTop: '100px',
    width: '100px',
    height: '100px',
  },
  textLarge: {
    padding: '20px',
    color: greyBDBDBD,
  },
  textSmall: {
    color: greyBDBDBD,
  },
});

// EXPORTED COMPONENT
// =========================
const EmptyState = (props) => {
  if (!props) {
    return null;
  }

  const { compactMode, pageText, pageTitle } = props;
  if (!compactMode) {
    return (
      <Grid container alignItems="center">
        <Grid item xs={12} sx={(theme) => styles(theme).gridItemCenterAlign}>
          <ActionPageview sx={(theme) => styles(theme).iconLarge} />
        </Grid>
        <Grid item xs={12} sx={(theme) => styles(theme).gridItemCenterAlign}>
          <Typography variant="h2" sx={(theme) => styles(theme).textLarge}>
            {pageTitle}
          </Typography>
        </Grid>
        <Grid item xs={12} sx={(theme) => styles(theme).gridItemCenterAlign}>
          <Typography variant="body1" component="div" sx={(theme) => styles(theme).textLarge}>
            {pageText}
          </Typography>
        </Grid>
      </Grid>
    );
  }

  return (
    <Grid container alignItems="center">
      <Grid
        sx={(theme) => styles(theme).gridItemRightAlign}
        item
        xs={6}
        style={{ display: 'flex' }}
      >
        <ActionPageview sx={(theme) => styles(theme).iconSmall} />
      </Grid>
      <Grid sx={(theme) => styles(theme).gridItemLeftAlign} item xs={6}>
        <Typography sx={(theme) => styles(theme).textSmall} variant="h4">
          {pageTitle}
        </Typography>
        <Typography sx={(theme) => styles(theme).textSmall} variant="body2">
          {pageText}
        </Typography>
      </Grid>
    </Grid>
  );
};

// PROPS
// =========================
EmptyState.propTypes = {
  compactMode: PropTypes.bool.isRequired,
  pageTitle: PropTypes.string,
  pageText: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

EmptyState.defaultProps = {
  compactMode: false,
  pageText: 'No data found...',
};

// EXPORT
// =========================
export default EmptyState;
